import i18next from "i18next"

export const IS_FNUCI_SYNC = 1

/**********************
 ***** Bike status ****
 **********************/
export const BIKE_STATUS_SOLD = 1
export const BIKE_STATUS_STOLEN = 2
export const BIKE_STATUS_DESTROY = 3
// export const BIKE_STATUS_IN_SEARCH = 4
export const BIKE_STATUS_IN_SALE = 5
export const BIKE_STATUS_BACK_IN_STORE = 6

type BikeStatus = {
	id: string
	value: number
	label: string
	color: string
}

export const bikeStatusList: BikeStatus[] = [
	{
		id: "sold",
		value: BIKE_STATUS_SOLD,
		label: i18next.t("status.in_service", { ns: "bike" }),
		color: "primary",
	},
	{
		id: "stolen",
		value: BIKE_STATUS_STOLEN,
		label: i18next.t("status.stolen", { ns: "bike" }),
		color: "secondary",
	},
	{
		id: "destroy",
		value: BIKE_STATUS_DESTROY,
		label: i18next.t("status.destroy", { ns: "bike" }),
		color: "destroyBike",
	},
	// {
	// 	id: "insearch",
	// 	value: BIKE_STATUS_IN_SEARCH,
	// 	label: i18next.t("bike.status.insearch"),
	// },
	{
		id: "insale",
		value: BIKE_STATUS_IN_SALE,
		label: i18next.t("status.in_sale", { ns: "bike" }),
		color: "insaleBike",
	},
	{
		id: "back_in_store",
		value: BIKE_STATUS_BACK_IN_STORE,
		label: i18next.t("status.in_store", { ns: "bike" }),
		color: "primary",
	},
]

export const unknownBikeStatus: BikeStatus = {
	id: "unknown",
	value: undefined,
	label: i18next.t("status.unknown", { ns: "bike" }),
	color: "secondary",
}
